module.exports = __webpack_public_path__ + "img/1470346825.0ef472b2.jpg";